"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _legoPagelife = _interopRequireDefault(require("../../lego-pagelife"));
var _common = require("../../utils/common");
var _cookie = require("../../utils/cookie");
var _lego = _interopRequireDefault(require("../../lego"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var sendData = function sendData(obj) {
  _lego.default.send(obj);
};
var initPvLister = function initPvLister(params, legoInit) {
  var pageIdInfo = (0, _common.getPageIdInfo)();
  if (!pageIdInfo || !pageIdInfo.pageId) {
    return;
  }

  // 初始化上一个页面的信息
  var referrerObj = {
    refpagetype: '',
    refpagequery: '',
    refsubpageID: '',
    refsectionId: '',
    refsortId: ''
  };

  // 从cookie中获取
  try {
    var referrerObjCookie = (0, _cookie.getCookie)('referrerObj');
    if (referrerObjCookie) {
      referrerObj = JSON.parse(referrerObjCookie);
    }
  } catch (e) {}

  // 从url里面获取
  var refpagequery = (0, _common.getQuery)('refpagequery');
  var refsubpageID = (0, _common.getQuery)('refsubpageID');
  refpagequery && (referrerObj.refpagequery = refpagequery);
  refsubpageID && (referrerObj.refsubpageID = refsubpageID);
  var userBackup = {};
  if (legoInit) {
    userBackup = legoInit.getUserBackup() || {};
  }
  var PVPagetype = 'zpmshow';
  if (params.pagetype || userBackup.pagetype || pageIdInfo.isDetailPage) {
    PVPagetype = 'CommodityDetail';
  }
  sendData({
    pagetype: PVPagetype,
    actiontype: pageIdInfo.pageId,
    backup: _objectSpread(_objectSpread(_objectSpread({}, userBackup), referrerObj), {}, {
      refsectionId: decodeURIComponent((0, _cookie.getCookie)('refsectionId')),
      refsortId: (0, _cookie.getCookie)('refsortId')
    })
  });
  var refererCache = (0, _common.cloneDeep)(referrerObj);
  // 更新参数在cookie中
  refererCache.refpagetype = pageIdInfo.pageId;
  refererCache.refpagequery = params.pagequery || '';
  refererCache.refsubpageID = params.subpageID || '';
  (0, _cookie.setCookie)({
    referrerObj: JSON.stringify(refererCache)
  });
};
var autoPvLister = function autoPvLister(params, legoInit) {
  _legoPagelife.default.add('onLoad', (0, _common.throttle)(function () {
    return initPvLister(params, legoInit);
  }, 1000));
};
var _default = autoPvLister;
exports.default = _default;